"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UserSettingsKeys = require("crm_data/settings/UserSettingsKeys");

var _images = require("crm_internal/constants/images");

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _onboardingTourHelpers = require("crm_internal/onboarding/onboardingTourHelpers");

var ONBOARDING_KEY = 'recordOnboarding';
var INTEGRATION_IMAGES = [_images.INTEGRATION_GMAIL, _images.INTEGRATION_GOTOWEBINAR, _images.INTEGRATION_SURVEYMONKEY, _images.INTEGRATION_ZAPIER, _images.INTEGRATION_EVENTBRITE, _images.INTEGRATION_PANDADOC];

var renderLightBulbIllustration = function renderLightBulbIllustration() {
  return _react.default.createElement(_UIIllustration.default, {
    width: "90px",
    name: "idea"
  });
};

var renderIntegrationImage = function renderIntegrationImage(imgSrc, key) {
  return _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 4
    },
    key: key
  }, _react.default.createElement(_UIImage.default, {
    style: {
      height: '70px'
    },
    src: imgSrc
  }));
};

var renderIntegrationGroup = function renderIntegrationGroup() {
  return _react.default.createElement("div", null, _react.default.createElement(_UIGrid.default, {
    className: "m-bottom-6"
  }, INTEGRATION_IMAGES.slice(0, 3).map(renderIntegrationImage)), _react.default.createElement(_UIGrid.default, null, INTEGRATION_IMAGES.slice(3, 6).map(renderIntegrationImage)));
};

var STEPS = [{
  name: 'start',
  content: {
    getMedia: renderLightBulbIllustration
  }
}, {
  name: 'properties',
  preloadMediaSources: [_images.DEMO_PROPERTIES_GIF],
  content: {
    getMedia: _images.DEMO_PROPERTIES_GIF
  }
}, {
  name: 'automation',
  preloadMediaSources: [_images.DEMO_COMPANY_PROPS_GIF],
  content: {
    getMedia: _images.DEMO_COMPANY_PROPS_GIF
  }
}, {
  name: 'timeline',
  preloadMediaSources: [_images.DEMO_TIMELINE_TASK_GIF],
  content: {
    getBody: function getBody() {
      return (0, _onboardingTourHelpers.renderParagraphs)('recordOnboarding', 'timeline', ['bodyLine1', 'bodyLine2']);
    },
    getMedia: _images.DEMO_TIMELINE_TASK_GIF
  }
}, {
  name: 'integrations',
  preloadMediaSources: [_images.INTEGRATION_GMAIL, _images.INTEGRATION_GOTOWEBINAR, _images.INTEGRATION_SURVEYMONKEY, _images.INTEGRATION_ZAPIER, _images.INTEGRATION_EVENTBRITE, _images.INTEGRATION_PANDADOC],
  content: {
    getMedia: renderIntegrationGroup
  }
}, {
  name: 'end',
  preloadMediaSources: [_images.DEMO_ADD_NOTE_GIF],
  content: {
    getMedia: _images.DEMO_ADD_NOTE_GIF
  }
}];
var _default = {
  onboardingKey: ONBOARDING_KEY,
  tourString: 'Record',
  steps: STEPS,
  completedKey: _UserSettingsKeys.HAS_COMPLETED_RECORD_ONBOARDING
};
exports.default = _default;
module.exports = exports.default;